import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { QueryClient, QueryClientProvider } from 'react-query';
import './AppStyles.scss';
import Footer from './Footer';
import NavBar from './NavBar';
import { actions } from '../actions/themeActions';
import { useFetching } from '../hooks/redux';

const useStyles = primaryColor => makeStyles(theme => {
  if (theme.palette.type === 'dark') {
    return ({
      '@global': {
        'body': {
          background: '#000',
          color: theme.palette.primary.dark,
        },
        '.navbar-wrapper': {
          background: '#000',
          borderBottomColor: theme.palette.primary.dark,
          borderBottomWidth: 2,
          borderBottomStyle: 'solid',
        },
        '.flex-nav .logo a span': {
          color: theme.palette.primary.dark,
        },
        '.box': {
          background: '#000',
          borderWidth: 1,
          borderColor: theme.palette.primary.dark,
          borderStyle: 'solid',
        },
        '.box h3': {
          color: theme.palette.primary.dark,
        },
        '.box h2': {
          color: theme.palette.primary.dark,
        },
        '.box-header-outside .header h2, .box .inner-content h3': {
          color: theme.palette.primary.dark,
        },
        '.box .date li': {
          color: theme.palette.primary.dark,
        },
        '.box .date li i': {
          color: theme.palette.primary.dark,
        },
        '.box .date': {
          borderColor: theme.palette.primary.dark,
        },
        '.card p': {
          color: theme.palette.primary.dark,
        },
        '.btn': {
          backgroundColor: theme.palette.primary.dark,
          color: '#000',
        },
        '.btn:focus': {
          color: '#000',
        },
        '.btn:hover': {
          color: '#000',
        },
        '.active-block': {
          boxShadow: `0px 0px 0px 1px ${theme.palette.primary.dark} inset`,
        },
        '.comments-icon': {
          color: theme.palette.primary.dark,
        },
        footer: {
          backgroundColor: '#000',
        },
        'footer p, footer li, footer span, footer p a': {
          color: theme.palette.primary.dark,
        },
        'footer .logo-link': {
          opacity: 1,
        },
        'footer .logo a img': {
          filter: 'grayscale(100%) brightness(120%) sepia(100%) hue-rotate(5deg) saturate(1000%) contrast(1)',
        },
        '.gm-style-iw-d': {
          color: theme.palette.primary.dark,
        },
        '.gm-style-iw-d div': {
          backgroundColor: '#000',
          padding: 2,
        },
        '.MuiSelect-iconOutlined': {
          color: theme.palette.primary.dark,
        },
        p: {
          color: theme.palette.primary.dark,
        },
        '.MuiTableCell-footer': {
          color: theme.palette.primary.dark,
        },
        '.wcag .controls .wrapper': {
          backgroundColor: 'transparent',
          borderWidth: 3,
          borderColor: theme.palette.primary.dark,
          borderStyle: 'solid',
        },
        '.wcag .controls .header.header-main span, .wcag .controls .link': {
          color: theme.palette.primary.dark,
          borderColor: theme.palette.primary.dark,
        },
        '.wcag .controls .link a': {
          color: theme.palette.primary.dark,
          textDecoration: 'underline',
        },
        '.wcag .controls .actions button span': {
          borderColor: theme.palette.primary.dark,
        },
        '.wcag .controls .header i, .wcag .controls .actions .header span': {
          color: theme.palette.primary.dark,
        },
        'h3.category.category span, .contrast_bw span, .contrast_by span, .project-name, .projects-table td:nth-child(2)': {
          color: theme.palette.primary.dark,
          borderColor: theme.palette.primary.dark,
        },
        '.projects-table .project-row, .projects-table .project-row-checkbox': {
          backgroundColor: '#000',
          color: theme.palette.primary.dark,
          borderColor: theme.palette.primary.dark,
        },
        'h3.category.category': {
          borderColor: theme.palette.primary.dark,
        },
      },
    });
  }

  return ({
    '@global': {
      '.btn': {
        backgroundColor: primaryColor,
      },
      '.btn:hover': {
        filter: `brightness(0.9)`,
      },
      '.box .date li': {
        color: primaryColor,
      },
      '.gallery .gallery-content': {
        backgroundColor: primaryColor,
      },
      '.active-block': {
        boxShadow: `0px 0px 0px 1px ${primaryColor} inset`,
      },
      '.comments-icon': {
        color: primaryColor,
      },
      '.image-picker-image': {
        borderColor: primaryColor,
      }
    },
  });
})();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const AppFrame = ({ unit, tenant, children }) => {
  useFetching(() => actions.initTheme(unit.color));
  useStyles(unit.color);
 
  return (
    <React.Fragment>
      <QueryClientProvider client={queryClient}>
        {tenant && unit ? <NavBar unit={unit} tenant={tenant} /> : null}
        <div className="container">
          {children}
        </div>
        {unit && <Footer unit={unit} tenant={tenant} />}
      </QueryClientProvider>
    </React.Fragment>
  );
};

AppFrame.propTypes = {
  children: PropTypes.node.isRequired,
  unit: PropTypes.object.isRequired,
  tenant: PropTypes.object.isRequired,
};

export default AppFrame;



// WEBPACK FOOTER //
// ./src/components/AppFrame.js